export default __webpack_public_path__ + "static/791-26beaa86e489af987041dc474d4daba2.gif";